import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import type { DateValue } from 'react-aria';
import { parseDateTime, today, getLocalTimeZone } from '@internationalized/date';
import { selectSurgeryDate, selectShowInvalids } from '@store/order/selectors';
import { setSurgeryDate } from '@store/order/slice';
import Calendar from '@components/calendar/Calendar';
import { invalidFormValue } from '@components/utils';



const SurgeryDate = () => {
	const { t } = useTranslation('forms');

	const surgeryDate = useSelector(selectSurgeryDate);
	const showInvalids = useSelector(selectShowInvalids);

	const dispatch = useDispatch();
	const updateSurgeryDate = (value: string | null) => dispatch(setSurgeryDate(value));

	return (
		<div className='surgery-date'>

			<label className='surgery-label'>
				{t('surgeryInfo.date.sectionLabel') + ' '}<span>*</span> {showInvalids && invalidFormValue(surgeryDate) &&
					<p className='form-invalid'>{t('validation.requiredField')}</p>}
			</label>

			<div className='surgery-calendar'>
				<Calendar
					aria-label="Date (controlled)"
					value={surgeryDate ? parseDateTime(surgeryDate) : null}
					minValue={today(getLocalTimeZone())}
					onChange={(e: DateValue) => updateSurgeryDate(e.toString())} />
			</div>

			<p><span>{t('surgeryInfo.date.textBold')}</span>{' ' + t('surgeryInfo.date.text')}</p>

		</div>
	);
};

export default SurgeryDate;